<template>
  <div class="main-contant">
    <el-row :gutter="10">
      <el-col :xs="6" :sm="6" :md="6" :lg="6">
        <div class="logo">
          <img class="logo_img" src="@/assets/logo.png">
        </div>
        <div class="setps-area">

          <div>
            <el-steps direction="vertical" :active="setepInfoData.currentStepNum" space="30%" :align-center="true"
              class="steps">

              <div v-if="setepInfoData.currentStepName == 'apply' || setepInfoData.currentStepName == 'continue'">
                <el-step class="step-titile" v-for="(item, index) in applySetpList" :key="'st1'+index">
                  <div slot="title">
                    <span v-html="item" />
                  </div>
                  <template slot="icon">
                    <img v-if="setepInfoData.currentStepNum == index" class="setp-icon"
                      src="@/assets/icon/loading.png" />
                    <img v-else-if="setepInfoData.currentStepNum < index" class="setp-icon"
                      src="@/assets/icon/lutaib.png" />
                    <img v-else="setepInfoData.currentStepNum < index" class="setp-icon"
                      src="@/assets/icon/success_fill.png"></img>
                  </template>
                </el-step>
              </div>
              <div v-if="setepInfoData.currentStepName == 'query'">
                <el-step class="step-titile" v-for="(item, index) in querySetpList" :key="'st2'+index">
                  <div slot="title">
                    <span v-html="item" />
                  </div>
                  <template slot="icon">
                    <img v-if="setepInfoData.currentStepNum == index" class="setp-icon"
                      src="@/assets/icon/loading.png" />
                    <img v-else-if="setepInfoData.currentStepNum < index" class="setp-icon"
                      src="@/assets/icon/lutaib.png" />
                    <img v-else="setepInfoData.currentStepNum < index" class="setp-icon"
                      src="@/assets/icon/success_fill.png"></img>
                  </template>
                </el-step>
              </div>
            </el-steps>
          </div>
        </div>
      </el-col>
      <el-col :xs="18" :sm="18" :md="18" :lg="18">
        <!-- 首页 -->
        <index v-if="setepInfoData.currentOperateName == 'home'" />
        <!-- 邮箱输入 -->
        <email-form v-if="setepInfoData.currentOperateName == 'emailQuery'" />
        <!-- 选择申请方式 -->
        <select-page v-if="setepInfoData.currentOperateName == 'selectPage'" />
        <!-- 个人信息表单 -->
        <personal-info v-if="setepInfoData.currentOperateName == 'personalInfo'" />
        <!-- 邮箱验证 -->
        <email-verify v-if="setepInfoData.currentOperateName == 'emailVerify'" />
        <!-- 住屋、生活及工作資料 -->
        <live-employment v-if="setepInfoData.currentOperateName == 'liveEmployment'" />
        <!-- 住屋、生活及工作資料[二人申請] -->
        <live-employment2 v-if="setepInfoData.currentOperateName == 'liveEmployment2'" />
        <!-- 申請資格聲明申請資格聲明 -->
        <declaration v-if="setepInfoData.currentOperateName == 'declaration'" />
        <!-- 个人资料预览 -->
        <information v-if="setepInfoData.currentOperateName == 'informationPreview'" />
        <!-- 申報及上傳檔案 -->
        <file-index v-if="setepInfoData.currentOperateName == 'fileIndex'" />
        <!-- 申報及上傳檔案 [二人申請]-->
        <file-index2 v-if="setepInfoData.currentOperateName == 'fileIndex2'" />
        <!-- 聲明、條款及細則 -->
        <terms v-if="setepInfoData.currentOperateName == 'terms'" />
        <!-- 申请成功 -->
        <apply-success v-if="setepInfoData.currentOperateName == 'applySuccess'" />
        <!-- 查询申请-输入条件 -->
        <query-condiction v-if="setepInfoData.currentOperateName == 'queryCondiction'" />

        <!-- 查询条件展示 -->
        <query-result v-if="setepInfoData.currentOperateName == 'queryResult'" />
      </el-col>
    </el-row>
    <drag-button></drag-button>
  </div>
</template>

<script>
  import Index from "./apply/index.vue";
  import EmailForm from "./apply/child/emailForm.vue";
  import SelectPage from "./apply/child/selectPage.vue";
  import PersonalInfo from "./apply/child/personalInfo.vue";
  import EmailVerify from "./common/emailVerify.vue";
  import LiveEmployment from "./apply/child/liveEmployment.vue";
  import LiveEmployment2 from "./apply/child/liveEmployment.vue";
  import Declaration from "./apply/child/declaration.vue";
  import Information from "./apply/child/information.vue";
  import FileIndex from "./upload/index.vue";
  import FileIndex2 from "./upload/index.vue";
  import ApplySuccess from "./common/applySuccess.vue";
  import Terms from "./apply/child/terms.vue";
  // 查询需要的页面
  import QueryCondiction from "./query/child/condiction.vue";
  import QueryResult from "./query/child/result.vue";
  import DragButton from "@/components/DragButton/index.vue";
  import {
    getContent
  } from "@/assets/js/api.js";
  export default {
    components: {
      Index,
      EmailForm,
      SelectPage,
      PersonalInfo,
      EmailVerify,
      LiveEmployment,
      LiveEmployment2,
      Declaration,
      Information,
      FileIndex,
      FileIndex2,
      ApplySuccess,
      Terms,
      QueryCondiction,
      QueryResult,
      DragButton
    },
    watch: {
      'setepInfoData.currentOperateName'() {
        this.setepInfoData = this.$store.getters.querySetepInfo;
      },
    },
    data() {
      return {
        setepInfoData: this.$store.getters.querySetepInfo,
        applySetpList: [
          "第一步 Step 1：<br />開立申請帳戶<br /> Create Application Account",
          "第二步 Step 2：<br />個人資料<br /> Personal Information",
          "第三步 Step 3：<br />驗證電郵<br />Verify Email",
          "第四步 Step 4：<br />住屋、生活及工作資料<br />Housing, Living, and<br /> Employment Information",
          "第五步 Step 5：<br />申請資格聲明<br />Application Eligibility<br /> Declaration",
          "第六步 Step 6：<br />申報及上傳檔案<br />Declaration and File Upload",
          "第七步 Step 7：<br />聲明、條款及細則<br /> Declaration, Terms, and Conditions",
        ],
        querySetpList: [
          "第一步Step 1：<br>驗證電郵<br>Verify Email",
          "第二步Step 2: <br> 查詢申請狀況<br>Application Status Enquiry",
        ]
      };
    },
    created() {
      this.setepInfoData = this.$store.getters.querySetepInfo;
    },


  };

</script>

<style>
  .setp-icon {
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/view/Home.vue